import { forwardRef } from 'react';
import CircleBackgroundIcon from '@/atoms/icons/CircleBackground';
import Size from '@enums/Size';
import IconButton from '@mui/material/IconButton';
import InformationIcon from '@pkg/icons/Information';
import ButtonColors from './colors/ButtonColors';

const InfoButton = forwardRef(function InfoButton(
  {
    color = 'light-blue',
    colorProps,
    onClick,
    Icon = <InformationIcon />,
    size = Size.SMALL,
    sx,
  },
  ref
) {
  const colors = colorProps ?? ButtonColors[color].contained.normal;

  return (
    <>
      <IconButton
        aria-label="More information"
        onClick={onClick}
        sx={{
          backgroundColor: 'transparent',
          opacity: 1,
          '&:hover': {
            backgroundColor: 'transparent',
            opacity: 0.8,
          },
          ...sx,
        }}
        ref={ref}
      >
        <CircleBackgroundIcon colorProps={colors} icon={Icon} size={size} />
      </IconButton>
    </>
  );
});

export default InfoButton;
